var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 448",
    style: {
      enableBackground: "new 0 0 512 448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69,16.4c21.9-21.9,57.4-21.9,79.3,0c0,0,0,0,0,0l49.5,49.5l-99.9,99.8l-49.5-49.5c-21.9-21.9-21.9-57.4,0-79.3 L69,16.4L69,16.4z M440.7,308.8c5.9,5.9,10.2,13.2,12.4,21.2l26,91.1c3.3,11.1-3,22.7-14.1,26c-3.9,1.2-8,1.2-11.9,0l-91.1-26 c-8-2.3-15.3-6.6-21.2-12.4L117.6,185.5l99.9-99.9L440.7,308.8L440.7,308.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/editImage.23a45fd59d39320458bf24abb037a264.svg";
export { ForwardRef as ReactComponent };